import { motion } from 'framer-motion';
import { X, Loader2, Sparkles, MessageSquarePlus } from 'lucide-react';

export default function RefineMissionModal({ open, value, onChange, refining, onClose, onSubmit }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/40 flex items-end sm:items-center justify-center z-50 p-4" onClick={onClose}>
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="bg-white rounded-3xl w-full max-w-md p-6 border-b-4 border-[#E5E5E5]"
        onClick={(e) => e.stopPropagation()}
        data-testid="refine-modal"
      >
        <div className="flex justify-between items-center mb-2">
          <div className="flex items-center gap-2">
            <MessageSquarePlus size={24} strokeWidth={3} color="#1CB0F6" />
            <h3 className="text-xl font-extrabold">Tell us more</h3>
          </div>
          <button onClick={onClose} className="p-1" data-testid="close-refine-modal">
            <X size={24} strokeWidth={3} />
          </button>
        </div>
        <p className="text-sm text-[#AFAFAF] font-bold mb-4">
          Add any detail about YOUR situation and your AI coach will rewrite this mission to fit you exactly.
        </p>
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="gm-input text-base"
          rows={5}
          maxLength={800}
          placeholder="e.g. I work 7am-9pm at my shop, only have 15 min free at 11am, my road is small village road, I have ₹2000/month to invest…"
          data-testid="refine-details-input"
        />
        <p className="text-right text-xs text-[#AFAFAF] font-extrabold mt-1">{value.length}/800</p>
        <button
          onClick={onSubmit}
          disabled={refining || value.trim().length < 3}
          className="gm-btn gm-btn-primary w-full text-lg py-3 mt-3"
          data-testid="submit-refine"
        >
          {refining ? (
            <><Loader2 size={20} strokeWidth={3} className="animate-spin" /> Re-analysing…</>
          ) : (
            <><Sparkles size={20} strokeWidth={3} /> Re-analyse mission</>
          )}
        </button>
      </motion.div>
    </div>
  );
}
